import { Card } from '../ui/Card';
import type { Grade } from '../../types/api.js';

interface ScoreGradeProps {
  /** グレード */
  grade: Grade;
  /** 総合スコア */
  total: number;
  /** グレード文字色 */
  gradeColor: string;
  /** グレード背景色 */
  gradeBg: string;
}

/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business グレードバッジ。S/A/B/C/Dグレードと総合スコアをglass cardに表示。Sグレード時はpulse-glowアニメーション
 * @graph-connects none
 */
export function ScoreGrade({ grade, total, gradeColor, gradeBg }: ScoreGradeProps) {
  return (
    <Card variant="glass" className="flex flex-col items-center gap-4 py-8">
      <div
        className={`grade-badge ${grade === 'S' ? 'animate-pulse-glow' : ''}`}
        style={{ color: gradeColor, backgroundColor: gradeBg }}
      >
        {grade}
      </div>
      <div className="text-center">
        <p className="text-3xl font-bold text-[var(--color-text-primary)]">
          {total}
          <span className="text-lg text-[var(--color-text-muted)] ml-1">/ 100</span>
        </p>
      </div>
    </Card>
  );
}
